const Moon: React.FC = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="548.087px"
      height="548.087px"
      viewBox="0 0 548.087 548.087"
      className="w-6 h-6 fill-current"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M189.818,528.559c123.706,52.317,287.13-4.908,339.15-118.961c-83.461,60.649-171.422,71.257-260.773,16.145
           c-78.642-48.507-115.884-123.322-104.367-214.266C178.484,95.743,251.691,31.581,365.833,10.818
           C260.055-22.601,98.724,18.293,36.899,177.213C-10.877,300.041,36.818,463.846,189.818,528.559z"
          />
          <path
            d="M350.423,116.556l35.565,34.435l-8.197,50.271c-1.257,7.711,3.546,11.465,10.727,8.384l44.048-18.895l44.048,18.895
           c7.181,3.081,11.717-0.624,10.135-8.278l-10.433-50.38l38.106-34.745c5.773-5.263,4.223-10.669-3.464-12.072l-48.111-8.78
           l-23.525-43.313c-3.729-6.866-9.775-6.866-13.505,0l-23.524,43.313l-48.116,8.784C346.49,105.576,344.809,111.117,350.423,116.556
           z"
          />
          <path
            d="M427.939,323.493l-34.623-6.315l-16.932-31.172c-2.685-4.94-7.034-4.94-9.719,0l-16.932,31.172l-34.619,6.315
           c-5.532,1.008-6.74,4.998-2.701,8.911l25.594,24.781l-5.899,36.178c-0.906,5.549,2.55,8.25,7.72,6.034l31.697-13.595
           l31.697,13.595c5.169,2.216,8.434-0.448,7.291-5.957l-7.507-36.255l27.422-25.002C434.589,328.39,433.471,324.501,427.939,323.493
           z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Moon;
